import { NavigationItem, TrendingSearchItem } from 'components/HeadMenu/types';

export const links = {
  PRICING: '/pricing',
  PROFILE: '/user/dashboard',
  INVITE: '/user/settings/referral',
  HELP: '/help',
};

export const getNavigationItemsList = (
  isDarkTheme: boolean
): NavigationItem[] => [
  {
    label: 'Product',
    items: [
      {
        type: 'links',
        label: 'Features',
        path: '/features',
        groups: [
          {
            items: [
              {
                label: 'Editor',
                path: '/features/editor',
                image: '/images/header/features/Editor.png',
                description: 'The most intuitive collaborative design platform',
              },
              {
                label: 'AI',
                path: '/features/ai',
                image: '/images/header/aiFeatures/imageGenerator.png',
                description: 'Enhance your workflow with AI companion tools',
              },
              {
                label: 'Infinite Canvas',
                path: '/features/infinite-canvas',
                image: '/images/header/features/infiniteCanvas.jpg',
                description: 'An expandable, adjustable, flexible workspace',
              },
              {
                label: 'Teams',
                path: '/features/teams',
                image: '/images/header/features/Teams.png',
                description:
                  'Collaborate in real time and do more with your team',
              },
            ],
          },
          {
            items: [
              {
                label: 'Fonts',
                path: '/features/fonts',
                image: '/images/header/features/fonts.png',
                description:
                  'Over 1,400 free fonts available for commercial use',
              },
              {
                label: 'Text Effects',
                path: '/features/text-effects',
                image: '/images/header/features/textEffects.png',
                description:
                  'One-click text effects and styling only found on Kittl',
              },
              {
                label: 'Asset Library',
                path: '/features/content-library',
                image: '/images/header/aiFeatures/artFeed.png',
                description:
                  'All the design assets you need in a single subscription',
              },
              {
                label: 'Mockups',
                path: '/tools/mockups',
                image: '/images/header/features/mockups.png',
                description: 'Generate high quality mockups for every use case',
              },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Solutions',
        path: '/solutions',
        groups: [
          {
            items: [
              { label: 'Marketing', path: '/solutions/marketing' },
              { label: 'Print on Demand', path: '/solutions/print-on-demand' },
              { label: 'Freelancers', path: '/solutions/freelancer' },
              { label: 'Branding', path: '/solutions/branding' },
            ],
          },
        ],
      },
      {
        type: 'banner',
        title: 'Kittl x Monotype',
        description:
          'Use iconic fonts like Helvetica, Futura, and Times New Roman on Kittl',
        image: {
          alt: 'Kittl x Monotype',
          url: '/images/header/Monotype_Navigation.jpg',
        },
        mainUrl: '/features/fonts/monotype',
      },
    ],
  },
  {
    label: 'Templates',
    items: [
      {
        type: 'links',
        label: 'Merchandise',
        path: '/templates?category=merchandise',
        groups: [
          {
            items: [
              { label: 'T-Shirts', path: '/templates/t-shirts' },
              { label: 'Bags', path: '/templates/bags' },
              { label: 'Hats', path: '/templates/hats' },
              { label: 'Stickers', path: '/templates/stickers' },
              { label: 'Tech Packs', path: '/templates/tech-packs' },
              { label: 'Book Covers', path: '/templates/book-covers' },
              { label: 'Album Covers', path: '/templates/album-covers' },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Marketing',
        path: '/templates?category=marketing',
        groups: [
          {
            items: [
              { label: 'Ads', path: '/templates/ads' },
              { label: 'Posters', path: '/templates/posters' },
              { label: 'Flyers', path: '/templates/flyers' },
              { label: 'Signs', path: '/templates/signs' },
              { label: 'Banners', path: '/templates/print-banners' },
              { label: 'Posts', path: '/templates/instagram-posts' },
              { label: 'Thumbnails', path: '/templates/youtube-thumbnails' },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Branding & Stationary',
        path: '/templates?category=branding',
        groups: [
          {
            items: [
              { label: 'Logos', path: '/templates/logos' },
              { label: 'Labels', path: '/templates/labels' },
              { label: 'Brand Boards', path: '/templates/brand-boards' },
              { label: 'Business Cards', path: '/templates/business-cards' },
              { label: 'Cards', path: '/templates/cards' },
              { label: 'Invitations', path: '/templates/invitations' },
              { label: 'Menus', path: '/templates/menus' },
            ],
          },
        ],
      },
      {
        type: 'banner',
        title: 'Design Kits',
        description:
          'Create standout designs fast with themed elements and templates',
        image: {
          alt: 'Design Kits',
          url: '/images/header/navbar-highlight_designkit.jpg',
        },
        mainUrl: '/templates/design-bundles',
      },
    ],
  },
  {
    label: 'Resources',
    items: [
      {
        type: 'links',
        label: 'Community',
        groups: [
          {
            items: [
              {
                label: 'Community',
                path: '/community ',
                image: isDarkTheme
                  ? '/images/newTheme/dark/small/Community.png'
                  : '/images/newTheme/light/small/Community.png',
                description:
                  'Join the Kittl community and connect with other designers',
              },
              {
                label: 'Blog',
                path: '/blog',
                image: isDarkTheme
                  ? '/images/newTheme/dark/small/Promotion.png'
                  : '/images/newTheme/light/small/Promotion.png',
                description: 'Explore tutorials, showcases, and updates',
              },
              {
                label: 'Tutorials',
                path: '/tutorials',
                image: isDarkTheme
                  ? '/images/newTheme/dark/small/Tutorials.png'
                  : '/images/newTheme/light/small/Tutorials.png',
                description:
                  'Learn Kittl and design with our easy-to-follow tutorials',
              },
              {
                label: 'Help Center',
                path: '/help',
                image: isDarkTheme
                  ? '/images/newTheme/dark/small/Help.png'
                  : '/images/newTheme/light/small/Help.png',
                description:
                  "Get all your questions answered about Kittl's features",
              },
              {
                label: 'Experts',
                path: '/partners/contra',
                image: isDarkTheme
                  ? '/images/newTheme/dark/small/Experts.png'
                  : '/images/newTheme/light/small/Experts.png',
                description:
                  'Post jobs and get hired to work on Kittl projects',
              },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Create Designs',
        path: '/create',
        groups: [
          {
            items: [
              { label: 'T-Shirts', path: '/create/t-shirts' },
              { label: 'Labels', path: '/create/labels' },
              { label: 'Logos', path: '/create/logos' },
              { label: 'Posters ', path: '/create/posters' },
              { label: 'Cards', path: '/create/cards' },
              { label: 'Signs', path: '/create/signs' },
              { label: 'Album Covers', path: '/create/album-covers' },
              { label: 'Book Covers', path: '/create/book-covers' },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'AI Tools',
        path: '/tools',
        groups: [
          {
            items: [
              {
                label: 'AI Image Generator',
                path: '/tools/image-generator',
              },
              {
                label: 'AI Vector Generator',
                path: '/tools/vector-generator',
              },
              { label: 'AI Vectorizer', path: '/tools/vectorizer' },
              {
                label: 'AI Background Remover',
                path: '/tools/ai-background-remover',
              },
              { label: 'AI Upscaler', path: '/feature/ai-image-upscaler' },
              {
                label: 'AI Background Generator',
                path: '/tools/background-generator',
              },
              { label: 'AI Logo Generator', path: '/tools/ai-logo-generator' },
              { label: 'AI Writing Tools', path: '/tools/writing' },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Mockups',
        path: '/tools/mockups',
        groups: [
          {
            items: [
              { label: 'T-Shirts', path: '/tools/mockups/t-shirts' },
              { label: 'Books', path: '/tools/mockups/books' },
              { label: 'Instagram', path: '/tools/mockups/instagram' },
              { label: 'Billboards', path: '/tools/mockups/billboards' },
              { label: 'Phones', path: '/tools/mockups/iphones' },
              { label: 'Mugs', path: '/tools/mockups/mugs' },
              { label: 'Posters', path: '/tools/mockups/posters' },
              { label: 'Tumblers', path: '/tools/mockups/tumblers' },
            ],
          },
        ],
      },
    ],
  },
  {
    label: 'Company',
    items: [
      {
        type: 'links',
        label: 'Company',
        groups: [
          {
            items: [
              { label: 'About Us', path: '/about' },
              { label: 'Contact', path: '/contact' },
              { label: 'Careers', path: '/careers' },
              { label: 'News & Media', path: '/news' },
              {
                label: 'Feature Request',
                path: 'https://feedback.kittl.com/feature-requests',
                isAbsolutePath: true,
              },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Plans',
        path: '/pricing',
        groups: [
          {
            items: [
              { label: 'Pricing', path: '/pricing' },
              {
                label: 'For Education ',
                path: '/education',
              },
            ],
          },
        ],
      },
      {
        type: 'links',
        label: 'Partnerships',
        path: '/partners',
        groups: [
          {
            items: [
              { label: 'Influencers', path: '/partners/influencers' },
              { label: 'Affiliates', path: '/affiliates' },
              {
                label: 'Creators',
                path: '/partners/creators',
              },
            ],
          },
        ],
      },
      {
        type: 'banner',
        title: 'Join Our Team',
        description:
          'See our current openings to find the best fit for you and your career goals',
        image: {
          alt: 'Join our team',
          url: '/images/header/joinOurTeam.jpg',
        },
        badge: 'Careers',
        mainUrl: '/careers',
      },
    ],
  },
];

export const trendingSearch: TrendingSearchItem[] = [
  {
    label: 'gaming',
    path: '/templates/logos/gaming?sort=popularity',
  },
  {
    label: 'monograms',
    path: '/templates/monograms?sort=popularity',
  },
  { label: 'vintage', path: '/templates/logos/vintage?sort=popularity' },
  {
    label: 'streetwear',
    path: '/templates/logos/streetwear?sort=popularity',
  },
  { label: 'y2k', path: '/templates/logos/y2k?sort=popularity' },
];
